// extracted by mini-css-extract-plugin
module.exports = {"mobileRoot":"TapBeerView_mobileRoot__Po7E8","logo":"TapBeerView_logo__3T7pI"};